import React from 'react';
import moment from 'moment';
import { connect } from 'react-redux';
import { change as formChange } from 'redux-form';
import _ from 'lodash';

import Hint from 'jbc-front/components/Hint';
import { ArrowDoublePrev, ArrowDoubleNext } from 'jbc-front/components/icons';
import { getList, getExtras } from 'src/reducers/common/listReducer';
import { getItem } from 'src/reducers/common/itemReducer';
import { MONTHS_COLORS } from 'src/features/Employees/components/EmployeeStandardMonthliesSection';
import image from 'src/features/Employees/images/img-insurance-amount.png';
import styles from './InsurancePeriodSetting.scss';
import { withTranslation } from 'react-i18next'
import { setGlobalErrors } from 'src/reducers/global';

// propsにminSelectableYearが渡されなかった場合のデフォルト
const defaultMinimumYear = moment().year() - 6;
const allMonths = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12];
const calYearMonth = (year, month) =>
  moment()
    .year(year)
    .month(month)
    .format('YYYYMM');

// ユーザーの保険設定の中から指定した日付に適用されている設定値を返す
// NOTE: このメソッドは、insurancesに最低1つの値が設定されていることを前提に作られている
// 2019/01時点では、ユーザー未設定状態では、日付は指定させないため当該コンポーネントが描画されることはない
// 設定以後は、システム上の最古日に設定値が作成されるため、日付がヒットしないケースも存在しない
// ※ 上記前提条件が崩れる場合は、当該メソッドの構成を見直すこと
export const findLatestInsurances = (yearMonth, insurances) => {
  const latestYearMonth = Object.keys(insurances)
    .find(i => i == yearMonth - 1)

  // const latestYearMonth = _.sortBy(Object.keys(insurances))
    // .reverse();
    // .find(i => i  <= yearMonth - 1);
  return (insurances[latestYearMonth] || []);
};

const isSame = ([, a], [, b]) => {
  const diffFields = [
    'contributionRateEmployee',
    'contributionRateEmployer'
  ];
  return diffFields.every(field => _.toString(a[field]) === _.toString(b[field]));
};

const MonthDiv = ({ month, onClick, isSelectingMonth, colorCount = 0 , language}) => {
  let tagClass = styles.tag;
  const hasLatestStandardStyle = {
    position: 'absolute',
    content: '',
    bottom: '-8px',
    left: '-1px',
    borderRadius: '4px',
    width: '32px',
    height: '3px',
    backgroundColor: MONTHS_COLORS[colorCount % MONTHS_COLORS.length]
  };

  if (isSelectingMonth(month)) {
    tagClass = styles.tagSelected;
  }

  return (
    <div className={`${tagClass} ${styles.tagSetted} u-cur-pointer`} role="presentation" onClick={() => onClick(month)}>
      {month}
      {language === "ja" ? <span className={styles.tagMonth}>月</span> : ""}
      <span style={hasLatestStandardStyle} />
    </div>
  );
};

class InsurancePeriodSetting extends React.Component {
  constructor(props) {
    super(props)
    moment.locale(this.props.i18n.language)
  }
  state = {
    year: moment().year(),
    selectingMonth: moment().month() + 1
  };

  // componentWillReceiveProps = () => moment.locale(this.props.i18n.language)

  trackCurrentMonth = checkYear => checkYear == moment().year() ? moment().month() + 1 : this.state.selectingMonth;

  changeMonth = newMonth => {
    if ((this.state.year == moment().year()) || this.state.year < moment().year()) {
      this.setState({ ...this.state, selectingMonth: newMonth });
      this.changeSettingStartDate(this.state.year, newMonth);
      this.updateInsuranceRate(this.state.year, newMonth);
      this.props.change(newMonth, this.state.year)
    }
    else {
      this.props.dispatch(setGlobalErrors(moment(newMonth, 'MM').format('MMMM') + " - " + this.state.year + " " + this.props.t("features.Clients.SocialSecurityContribution.Error.not_avaliable")))
    }
  };

  changeYear = newYear => {
    if (newYear <= moment().year()) {
      this.setState({ year: newYear, selectingMonth: this.trackCurrentMonth(newYear) });
      this.changeSettingStartDate(newYear, this.trackCurrentMonth(newYear));
      this.updateInsuranceRate(newYear, this.trackCurrentMonth(newYear));
      this.props.change(this.trackCurrentMonth(newYear), newYear);
    }
    else {
      this.props.dispatch(setGlobalErrors(newYear + " " + this.props.t("features.Clients.SocialSecurityContribution.Error.year_not_avaliable")))
    }
  };

  isSelectingMonth = month => this.state.selectingMonth === month;
  buildPeriodTextPay = () => {
    let textFormat = '';
    let month = this.state.selectingMonth;
    textFormat = this.props.i18n.language !== "ja" ? 'MMMM YYYY' : 'YYYY年M月支給分に適用';
    switch (this.props.insuranceType) {
      case 'healthInsurance':
        textFormat = 'YYYY年M月支給分に適用';
        break;
      case 'pensionInsurance':
        textFormat = 'YYYY年M月支給分に適用';
        break;
      case 'employmentInsurance':
        month = +month - 1;
        textFormat = 'YYYY年M月に対象期間終了日が属する場合に適用';
        break;
      case 'accidentInsurance':
        month = +month - 1;
        textFormat = 'YYYY年M月に対象期間終了日が属する場合に適用';
        break;
      default:
        break;
    }

    return moment()
      .year(this.state.year)
      .month(month)
      .format(textFormat);
  };

  buildPeriodTextBonus = () => {
    let textFormat = '';
    const month = +this.state.selectingMonth - 1;
    textFormat = this.props.i18n.language !== "ja" ? 'MMMM YYYY' : 'YYYY年M月支給分に適用';
    
    switch (this.props.insuranceType) {
      case 'healthInsurance':
        textFormat = 'YYYY年M月支給分に適用';
        break;
      case 'pensionInsurance':
        textFormat = 'YYYY年M月支給分に適用';
        break;
      case 'employmentInsurance':
        textFormat = 'YYYY年M月支給分に適用';
        break;
      case 'accidentInsurance':
        textFormat = 'YYYY年M月支給分に適用';
        break;
      default:
        break;
    }

    return moment()
      .year(this.state.year)
      .month(month)
      .format(textFormat);
  };

  changeSettingStartDate = (year, month) => {
    const { formName, fieldName, dispatch } = this.props;
    const value = moment()
      .year(year)
      .month(month - 1)
      .format('YYYY-MM-01');
    dispatch(formChange(formName, fieldName, value));
  };

  updateInsuranceRate = (year, month) => {
    const { formName, dispatch, insurances, updateFields } = this.props;
    const latestInsurance = findLatestInsurances(month, insurances);
    if (latestInsurance) {
      updateFields.map(field => dispatch(formChange(formName, field, latestInsurance[field])));
    }
  };

  render() {
    const selectingYear = this.state.year;
    const { insurances, minSelectableYear, t } = this.props;
    const minYear = minSelectableYear || defaultMinimumYear;
    const canSelectPrevYear = selectingYear > minYear;
    const colorCounts = [];
    const sortedInsurances = _.sortBy(Object.entries(insurances), ([key]) => key);
    sortedInsurances.forEach(insurance => {
      if (colorCounts.findIndex(oldInsurance => isSame(oldInsurance, insurance)) < 0) {
        colorCounts.push(insurance);
      }
    });
    return (
      <React.Fragment>
        <div className={styles.select}>
          <div
            className={styles.prev}
            disabled={!canSelectPrevYear}
            role="presentation"
            onClick={() => this.changeYear(selectingYear - 1)}
          >
            {canSelectPrevYear && <ArrowDoublePrev size={7} />}
          </div>
          <div className={styles.year}>{selectingYear}</div>
          <div className={styles.month} role="presentation">
            {allMonths.map(month => {
              const yearMonth = calYearMonth(selectingYear, month);
              const latest = _.findLast(sortedInsurances, ([key]) => key < yearMonth);
              let colorCount = 0;
              if (latest) {
                colorCount = colorCounts.findIndex(insurance => insurance && isSame(insurance, latest));
              }
              return (
                <MonthDiv
                  key={month}
                  month={month}
                  onClick={this.changeMonth}
                  isSelectingMonth={this.isSelectingMonth}
                  colorCount={colorCount}
                  language={this.props.i18n.language}
                />
              );
            })}
          </div>
          <div className={styles.next} role="presentation" onClick={() => this.changeYear(selectingYear + 1)}>
            <ArrowDoubleNext size={7} />
          </div>
        </div>

        <div className={styles.payment}>
          <dl>
            <dt>{t('features.Clients.SocialSecurityContribution.MonthlySocialSecurityContribution.salary')} ： </dt>
            <dd>{this.props.i18n.language !== "ja" ? t('features.Clients.SocialSecurityContribution.MonthlySocialSecurityContribution.apply_in') : ""}{this.buildPeriodTextPay()}</dd>
          </dl>
          <dl>
            <dt>{t('features.Clients.SocialSecurityContribution.MonthlySocialSecurityContribution.bonus')} ： </dt>
            <dd>{this.props.i18n.language !== "ja" ? t('features.Clients.SocialSecurityContribution.MonthlySocialSecurityContribution.applied_in') : ""}{this.buildPeriodTextBonus()}</dd>
          </dl>
          <dl>
            <dt />
            <dd>
              <Hint
                text={
                  <div className={styles.exampleWrap}>
                    <div className={styles.exampleImg}>
                      <img src={image} alt="標準報酬月額イメージ" />
                    </div>
                    <p className={styles.exampleText}>保険料率が同じ月は同色で表示されます</p>
                  </div>
                }
              />
            </dd>
          </dl>
        </div>
      </React.Fragment>
    );
  }
}

export default connect(state => ({
  // insurances: getList(REDUCER_NAME, state),
  // insurances: getItem(REDUCER_NAME, state),
  // minSelectableYear: _.get(getExtras(REDUCER_NAME, state), 'minSelectableYear', null)
}))(withTranslation()(InsurancePeriodSetting));
